module.exports = __webpack_public_path__ + "static/media/foodshot14.7229da34.JPG";